/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../../Components/Core/Layout';
import SEO from '../../Components/Core/Seo';
import BackToTop from '../../Components/Core/BackToTop';
import PageBuilder from '../../Components/Core/PageBuilder';
import FAQCategory from '../../Components/Screens/FAQ/FAQCategory';

const pageTemplate = {
  'faq-sub-category': FAQCategory,
};

const FAQsCategoryPage = ({ location, data }) => {
  const {
    contentfulFaqPageLayout: {
      languageToggle,
      customHeader,
      sections,
      customFooter,
      internal: { type },
    },
  } = data;
  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      contentType={type}
      promoCode={null}
    >
      <PageBuilder sections={sections} template={pageTemplate} />
      <BackToTop />
    </Layout>
  );
};

FAQsCategoryPage.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

export default FAQsCategoryPage;

export const query = graphql`
  query FAQsPageByContentfulID(
    $locale: String = "en-CA"
    $contentful_id: String!
  ) {
    contentfulFaqPageLayout(
      contentful_id: { eq: $contentful_id }
      node_locale: { eq: $locale }
    ) {
      id
      contentful_id
      node_locale
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      pageSlug
      internal {
        type
      }
      ...global_faq_header
      sections {
        ...simple_image_banner
        ...faq_sub_category_block
      }
      ...global_faq_footer
    }
  }
`;

export const Head = ({ location, data, pageContext }) => {
  return (
    <SEO
      data={data.contentfulFaqPageLayout}
      pageContext={pageContext}
      location={location}
    />
  );
};
